import Level2 from './index'

export default [{
    path: '/level2',
    name:'level2',
    component: Level2
}]
